export const CREATE_CUSTOMERS_ATTACHMENT_REQUEST = 'CREATE_CUSTOMERS_ATTACHMENT_REQUEST';
export const CREATE_CUSTOMERS_ATTACHMENT_SUCCESS = 'CREATE_CUSTOMERS_ATTACHMENT_SUCCESS';
export const CREATE_CUSTOMERS_ATTACHMENT_FAILURE = 'CREATE_CUSTOMERS_ATTACHMENT_FAILURE';
